import React, { useCallback, useMemo } from 'react'
import { Grid, Row, Col, Checkbox } from 'react-bootstrap'
import { Button } from 'syft-acp-atoms/Button'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'

import DataDropdown from './DataDropdown'
import { filterSelectedFromOptions } from './dataAgenciesDropdownHelpers'

import { DataAgenciesDropdownItemProps } from './DataAgenciesDropdown.types'

const DataAgenciesDropdownItem = ({
  agency,
  options,
  values,
  header,
  deletable,
  editable,
  disabled,
  onChange,
  onDeleteClick,
  onChangeAllowCancellations,
}: DataAgenciesDropdownItemProps) => {
  const isAllowed24HoursDeletion = useFlexFlagIsOn('pte_41607_last_minute_booking_cancels')
  const filteredOptions = useMemo(
    () =>
      filterSelectedFromOptions({
        options: options,
        values,
        selected: agency.agency_id,
      }),
    [options, values, agency],
  )
  const handleChangeDropdown = useCallback(
    value => onChange(value, agency.rank, agency.id),
    [agency.rank, agency.id, onChange],
  )
  const handleChangeAllowCancellations = useCallback(
    () => onChangeAllowCancellations(agency.agency_id),
    [agency.agency_id, onChangeAllowCancellations],
  )
  const handleDelete = useCallback(() => onDeleteClick(agency.rank), [agency.rank, onDeleteClick])

  return (
    <Grid key={agency.rank}>
      <Row className="dropdown-row">
        <Col md={1}># {agency.rank}</Col>
        <Col md={deletable ? 5 : 8}>
          <DataDropdown
            onChange={handleChangeDropdown}
            options={filteredOptions}
            header={header}
            value={agency.agency_id}
            editable={editable}
            disabled={disabled}
          />
        </Col>
        {isAllowed24HoursDeletion && (
          <Col md={1}>
            <Checkbox
              style={{ placeSelf: 'center', marginTop: '5px' }}
              checked={agency?.allow_short_notice_booking_cancellations}
              onChange={handleChangeAllowCancellations}
              disabled={!agency.agency_id}
            />
          </Col>
        )}
        {deletable && (
          <Col md={2}>
            <Button kind="danger" onClick={handleDelete} disabled={!agency.agency_id && !values?.length}>
              Delete agency rank
            </Button>
          </Col>
        )}
      </Row>
    </Grid>
  )
}

export default DataAgenciesDropdownItem
